import './imposter.css'
import './web_component'
import React from 'react'
import { ImposterLayoutProps } from './types'

export const Imposter: React.FC<ImposterLayoutProps> = ({ children, ...props }) => (
  <imposter-l {...props}>{children}</imposter-l>
)
